import { ArrowRight, Blocks, Bot, CheckCircle2, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { modulesForUser } from "../../app/moduleRegistry";
import { useAuth } from "../../app/AuthContext";

export function PlatformHomePage() {
  const { user } = useAuth();
  const modules = modulesForUser(user);
  return (
    <>
      <section className="platform-hero">
        <div>
          <span className="kicker">ELMONET</span>
          <h1>Ällistämö Express</h1>
          <p>Yhtenäinen työpöytä ElmoNetin liiketoiminnan työjonojen, robottien ja prosessien hallintaan.</p>
        </div>
        <div className="platform-hero__visual" aria-hidden="true">
          <span><Blocks /></span><i /><span><Bot /></span><i /><span><CheckCircle2 /></span>
        </div>
      </section>

      <div className="platform-stats">
        <div><span className="platform-stat__icon"><Blocks /></span><strong>{modules.length}</strong><small>Käytettävää moduulia</small></div>
        <div><span className="platform-stat__icon"><CheckCircle2 /></span><strong>Toiminnassa</strong><small>Palvelun tila</small></div>
        <div><span className="platform-stat__icon"><Bot /></span><strong>Laajennettava</strong><small>Automaatioalusta</small></div>
      </div>

      <section className="platform-section">
        <div className="platform-section__heading">
          <div>
            <h2>Työalueet</h2>
            <p>Valitse käytettävä Ällistämö Express -moduuli.</p>
          </div>
        </div>
        <div className="module-grid">
          {modules.map((module) => (
            <Link className="module-card module-card--active" to={module.path} key={module.id}>
              <div className={`module-card__mark module-card__mark--${module.accent}`}>{module.shortName}</div>
              <div className="module-card__status"><span /> Käytössä</div>
              <h3>{module.name}</h3>
              <p>{module.description}</p>
              <div className="module-card__footer">Avaa moduuli <ArrowRight /></div>
            </Link>
          ))}
          {!modules.length && <div className="card no-module-access"><ShieldCheck /><h3>Ei vielä moduulioikeuksia</h3><p>Ylläpitäjä voi myöntää käyttöoikeuden tarvittavaan moduuliin.</p></div>}
        </div>
      </section>
    </>
  );
}
